/* ---------- ortak overlay gözlemcisi ----------
 * Drawer / mobil menü / modal açıkken <html data-overlay-open> işaretlenir.
 * Product Quiz ve Campaign Strip CSS'i bunu okuyup kendini gizler.
 * İki component de aynı kodu taşır; global bayrak sayesinde yalnızca biri çalışır,
 * yani tek section kurulu olsa da çalışır, ikisi birlikteyse çift gözlemci olmaz.
 *
 * Tema class adı tahmin etmek yerine davranışa bakılır: neredeyse her drawer
 * body scroll'unu kilitler. Bilinen selector'lar ikinci savunma hattı.
 */
(function () {
  if (window.__themeOverlayWatch) return;
  window.__themeOverlayWatch = true;

  const SELECTORS = [
    'cart-drawer[open]',
    'cart-drawer.active',
    'cart-notification.active',
    '.drawer.is-open',
    '.drawer--is-open',
    '.drawer.active',
    '[data-drawer].is-open',
    '.menu-drawer[open]',
    'details[open] > .menu-drawer',
    '#CartDrawer.active',
    '.modal--is-active',
    '.modal.is-open',
    '.overlay.is-visible',
    'dialog[open]',
  ].join(',');

  const scrollLocked = () => {
    const b = getComputedStyle(document.body);
    const h = getComputedStyle(document.documentElement);
    // overflowY'ye bakılır: birçok tema body/html'e global overflow-x: hidden verir,
    // shorthand'e bakmak yanlış pozitif üretirdi.
    return (
      b.overflowY === 'hidden' ||
      b.position === 'fixed' ||
      h.overflowY === 'hidden' ||
      document.body.classList.contains('js-drawer-open') ||
      document.body.classList.contains('overflow-hidden') ||
      document.body.classList.contains('no-scroll')
    );
  };

  let last = null;
  const sync = () => {
    let open = scrollLocked();
    if (!open) {
      try {
        open = !!document.querySelector(SELECTORS);
      } catch (e) {
        open = false;
      }
    }
    if (open === last) return;
    last = open;
    if (open) document.documentElement.setAttribute('data-overlay-open', '1');
    else document.documentElement.removeAttribute('data-overlay-open');
  };

  const schedule = () => requestAnimationFrame(sync);

  new MutationObserver(schedule).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'style'],
  });
  new MutationObserver(schedule).observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style'],
  });

  // Drawer açılışları kullanıcı eylemiyle olur; animasyon bitince tekrar bak.
  ['click', 'keydown', 'transitionend'].forEach((ev) =>
    document.addEventListener(ev, () => {
      schedule();
      setTimeout(sync, 350);
    }, true)
  );

  sync();
})();

/* Campaign Strip — sabit alt şerit
 * Yaşam döngüsü: dismissed? -> delay -> göster -> her saniye countdown -> süre bitti? -> gizle
 */
(function () {
  const DISMISS_PREFIX = 'cs:dismissed:';

  const ICONS = {
    gift: ['M4 11h16v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9z', 'M3 7h18v4H3V7z', 'M12 7v14', 'M12 7C10.5 4 9 3 7.8 3.4 6.4 3.9 6.4 6 8 7h4zM12 7c1.5-3 3-4 4.2-3.6 1.4.5 1.4 2.6-.2 3.6h-4z'],
    percent: ['M19 5L5 19', 'M7.5 9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z', 'M16.5 19.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z'],
    truck: ['M3 7h10v9H3V7z', 'M13 10h4l3 3v3h-7v-6z', 'M7 19.5a1.8 1.8 0 1 0 0-3.5 1.8 1.8 0 0 0 0 3.5z', 'M17 19.5a1.8 1.8 0 1 0 0-3.5 1.8 1.8 0 0 0 0 3.5z'],
    sparkle: ['M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z'],
    bag: ['M6 7h12l-1 13H7L6 7z', 'M9 7a3 3 0 0 1 6 0'],
    droplet: ['M12 3s6 6.4 6 10.5A6 6 0 0 1 6 13.5C6 9.4 12 3 12 3z'],
    clock: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 7.5V12l3 2'],
  };

  const COPY_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M9 9h10v10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9z"/><path d="M15 6V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h1"/></svg>';
  const DONE_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M4 12.5l5 5L20 6.5"/></svg>';

  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
    );

  const icon = (name, cls) => {
    const d = ICONS[name] || ICONS.gift;
    return `<svg class="${cls}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d
      .map((p) => `<path d="${p}"/>`)
      .join('')}</svg>`;
  };

  class CampaignStrip extends HTMLElement {
    connectedCallback() {
      const cfgEl = this.querySelector('[data-strip-config]');
      if (!cfgEl) return;
      try {
        this.cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        console.warn('[campaign-strip] geçersiz config', e);
        return;
      }
      if (!this.cfg.title) return;

      this.L = this.cfg.labels || {};
      this.end = this.cfg.endDate ? new Date(this.cfg.endDate) : null;
      if (this.end && isNaN(this.end)) {
        console.warn('[campaign-strip] end date parse edilemedi:', this.cfg.endDate);
        this.end = null;
      }
      // Süresi geçmiş kampanya hiç render edilmez.
      if (this.end && this.end.getTime() <= Date.now()) return;
      if (this.cfg.rememberClose && this.isDismissed()) return;

      this.build();

      const delay = (this.cfg.delay || 0) * 1000;
      this.timer = setTimeout(() => this.show(), delay);

      document.addEventListener('shopify:section:select', this.onSectionSelect);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.copyTimer);
      clearInterval(this.ticker);
      this.release();
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
    }

    key() {
      return DISMISS_PREFIX + (this.dataset.signature || 'default');
    }
    isDismissed() {
      try {
        return localStorage.getItem(this.key()) === '1';
      } catch (e) {
        return false;
      }
    }

    build() {
      const pos = this.dataset.position === 'left' ? 'cs-strip--left' : 'cs-strip--right';
      // mode ayrımı Liquid'de yapılır: 'code' modunda ctaLabel boş gelir,
      // 'link' modunda code boş gelir. Burada sadece gelene bakılır.
      const mode = `cs-strip--${this.cfg.mode || 'code'}`;
      const hasCta = this.cfg.ctaLabel && this.cfg.ctaUrl;

      // Kupon pill'inin tamamı bir button — her yerine basınca kopyalar.
      const code = this.cfg.code
        ? `<button type="button" class="cs-code" data-copy="${esc(this.cfg.code)}" title="${esc(this.L.copy)}">
             ${this.L.code ? `<span class="cs-code__prefix">${esc(this.L.code)}</span>` : ''}
             <span class="cs-code__value">${esc(this.cfg.code)}</span>
             <span class="cs-code__icon" data-copy-icon>${COPY_ICON}</span>
           </button>
           <span class="cs-code__status" data-copy-status role="status" aria-live="polite"></span>`
        : '';
      this.insertAdjacentHTML(
        'beforeend',
        `
        <aside class="cs-strip ${pos} ${mode}" data-strip hidden role="complementary" aria-label="${esc(this.cfg.title)}">
          <div class="cs-strip__inner">
            <span class="cs-strip__icon">${icon(this.cfg.icon, 'cs-strip__icon-svg')}</span>
            <div class="cs-strip__text">
              <div class="cs-strip__title">${esc(this.cfg.title)}</div>
              ${this.cfg.subtext ? `<div class="cs-strip__subtext">${esc(this.cfg.subtext)}</div>` : ''}
              ${
                this.cfg.showCountdown && this.end
                  ? `<div class="cs-strip__countdown" data-countdown aria-live="off"></div>`
                  : ''
              }
              ${code || hasCta ? `<div class="cs-strip__actions">${code}${
                hasCta
                  ? `<a class="cs-strip__cta" href="${esc(this.cfg.ctaUrl)}">${esc(this.cfg.ctaLabel)}</a>`
                  : ''
              }</div>` : ''}
            </div>
            <button type="button" class="cs-strip__close" data-dismiss aria-label="${esc(this.L.close)}">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
            </button>
          </div>
        </aside>`
      );

      this.strip = this.querySelector('[data-strip]');
      this.countdownEl = this.querySelector('[data-countdown]');
      this.addEventListener('click', this.onClick);
    }

    show() {
      this.strip.hidden = false;
      if (this.end) {
        this.tick();
        this.ticker = setInterval(() => this.tick(), 1000);
      }
      this.claim();
    }

    hide() {
      clearInterval(this.ticker);
      this.strip.hidden = true;
      this.release();
    }

    onClick = (e) => {
      const copyBtn = e.target.closest('[data-copy]');
      if (copyBtn) return this.copyCode(copyBtn);

      if (!e.target.closest('[data-dismiss]')) return;
      this.hide();
      if (this.cfg.rememberClose) {
        try {
          localStorage.setItem(this.key(), '1');
        } catch (err) {
          /* private mode */
        }
      }
    };

    /* ---------- kupon kodu kopyalama ---------- */
    async copyCode(btn) {
      const code = btn.dataset.copy;
      let ok = false;

      // navigator.clipboard secure context ister; tema editörü iframe'inde
      // permissions policy ile bloklanabiliyor, o yüzden execCommand fallback'i var.
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          ok = true;
        }
      } catch (e) {
        ok = false;
      }
      if (!ok) ok = this.legacyCopy(code);

      const status = this.querySelector('[data-copy-status]');
      const iconEl = btn.querySelector('[data-copy-icon]');
      if (status) status.textContent = ok ? this.L.copied : this.L.copyFailed;
      btn.classList.toggle('is-copied', ok);
      if (iconEl && ok) iconEl.innerHTML = DONE_ICON;

      clearTimeout(this.copyTimer);
      this.copyTimer = setTimeout(() => {
        if (status) status.textContent = '';
        btn.classList.remove('is-copied');
        if (iconEl) iconEl.innerHTML = COPY_ICON;
      }, 2200);
    }

    legacyCopy(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-1000px;opacity:0;';
      document.body.appendChild(ta);
      ta.select();
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(ta);
      return ok;
    }

    /* ---------- countdown ---------- */
    tick() {
      const ms = this.end.getTime() - Date.now();
      if (ms <= 0) return this.hide();
      if (!this.countdownEl) return;

      const s = Math.floor(ms / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sec = s % 60;
      const pad = (n) => String(n).padStart(2, '0');

      const parts = [];
      if (d > 0) parts.push(`${d}${this.L.days}`);
      parts.push(`${pad(h)}${this.L.hours}`, `${pad(m)}${this.L.minutes}`, `${pad(sec)}${this.L.seconds}`);
      this.countdownEl.textContent = `${this.L.endsIn} ${parts.join(' ')}`;
    }

    /* ---------- diğer sabit elemanlarla çakışma ---------- */
    // Şerit görünürken <html data-campaign-strip> işaretlenir ve yüksekliği
    // --cs-height olarak yayınlanır; quiz FAB'ı mobilde bu kadar yukarı kayar.
    claim() {
      const h = this.strip.offsetHeight;
      document.documentElement.style.setProperty('--cs-height', h + 'px');
      document.documentElement.setAttribute('data-campaign-strip', '1');
    }
    release() {
      document.documentElement.removeAttribute('data-campaign-strip');
      document.documentElement.style.removeProperty('--cs-height');
    }

    /* ---------- tema editörü: gecikmeyi ve kapatmayı atla ---------- */
    onSectionSelect = (e) => {
      if (e.detail?.sectionId !== this.dataset.sectionId) return;
      clearTimeout(this.timer);
      if (this.strip) this.show();
    };
  }

  if (!customElements.get('campaign-strip')) customElements.define('campaign-strip', CampaignStrip);
})();